<template>
  <div class="choice">
    <div @click="homese">
      <img class="img1" src="../assets/picture.png" />
    </div>
    <div>
      <img class="img2" src="../assets/logo2.png" />
    </div>
    <div class="turn dropdown">
      <el-dropdown>
        <span class="el-dropdown-link">
          交易服务
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link style="color: #606266" to="/seemore">
              挂牌项目
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link style="color: #606266" to="/openlicense">
              开放许可
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link style="color: #606266" to="/deal">
              成交公告
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link style="color: #606266" to="/policylist">
              政策规则
            </router-link>
          </el-dropdown-item>
          <!-- <el-dropdown-item>
            <router-link style="color: #606266" to="/openlist">
              开放许可
            </router-link>
          </el-dropdown-item> -->
          <el-dropdown-item>
            <router-link style="color: #606266" to="/supermarket">
              专利超市
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link style="color: #606266" to="/interconnection">
              信息互联
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <a href="https://www.shexgrp.com/zscqzlk/011001/property_list.html" target="_blank"
              style="color: #606266">专利转化</a>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link style="color: #606266" to="/copyright_services">
              版权服务
            </router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link style="color: #606266" to="/pudong-patent">
              浦东新区专利公开实施
            </router-link>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="Bar">|</span>

      <el-dropdown>
        <span class="el-dropdown-link">
          运营服务
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toUrl('/consult')">
            IP咨询
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/trusteeship')">
            IP托管
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/operationaldevelopment')">
            IP运营开发
          </el-dropdown-item>
          <el-dropdown-item @click.native="toUrl('/demand')">
            IP需求开发
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="Bar">|</span>
      <el-dropdown>
        <span class="el-dropdown-link">
          金融服务
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="service">知识产权质押融资</el-dropdown-item>
          <el-dropdown-item @click.native="service2">知识产权质物处置</el-dropdown-item>
          <el-dropdown-item @click.native="operation">知识产权资本运作</el-dropdown-item>
          <el-dropdown-item @click.native="plate">服务科创板</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="Bar">|</span>
      <el-dropdown>
        <span class="el-dropdown-link">
          国际业务
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/union" style="color: #606266">国际联盟</router-link>
          </el-dropdown-item>
          <!-- <el-dropdown-item>一带一路服务</el-dropdown-item>
          <el-dropdown-item>海外预警与维权</el-dropdown-item>
          <el-dropdown-item>国际运营基金</el-dropdown-item>
          <el-dropdown-item>国际IP保险</el-dropdown-item>
          <el-dropdown-item>国际IP并购</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <span class="Bar">|</span>
      <el-dropdown>
        <span class="el-dropdown-link">
          重点产业
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toKey(0)">生物医药</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(1)">农业科技</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(2)">人工智能</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(3)">航天航空</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(4)">集成电路</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(5)">新一代信息技术</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(6)">新能源</el-dropdown-item>
          <el-dropdown-item @click.native="toKey(7)">新材料</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="personal flex-end-center">
      <div v-if="!showPerson">
        <span>
          <!-- showPopup = true;
              business = 'login'; -->
          <span style="cursor: pointer" @click="loginUser">登录</span>
          <span>/</span>
          <!-- @click="
                            showPopup = true;
                            business = 'regester';
                        " -->
          <span style="cursor: pointer" @click="register">注册</span>
        </span>
        <!-- <log-in :showPopup="showPopup"></log-in> -->
        <!-- <center-dialog
                    :show.sync="showPopup"
                    :business="business"
                    @handleShow="handleShow"
                ></center-dialog> -->
      </div>
      <!--  && loginFlag -->
      <div v-else-if="showPerson">
        <img src="../assets/ellipse.png" v-if="!showImg" />
        <img :src="userInfo.photo" v-else />
        <p style="cursor: pointer" @click="jumpPage">个人中心</p>
        <p style="cursor: pointer; margin-left: 6px" @click="out">退出</p>
      </div>
      <div style="cursor: pointer" @click="toCollection">我的收藏</div>
      <!-- <div>中/En</div> -->
      <!-- <el-button class="button" size="small "></el-button>
      <el-button class="button" size="small ">我的收藏</el-button>
      <el-button size="small ">中/En</el-button> -->
    </div>
    <!-- 忘记密码（修改密码弹窗） -->
    <change-password></change-password>
  </div>
</template>

<script>
import { getUSER, getJWT, removeUSER, getLoginUrl, setJWT, setUSER, getRegisterUrl } from "../api/constant";
import { getRequest } from "../api/api";
import { getUrlParam } from "../api/util";

import ChangePassword from "./ChangePassword.vue";
// import {removeUSER} from "../api/constant";

export default {
  components: { ChangePassword },
  data() {
    return {
      // 是否展示个人中心
      userInfo: {},
      // showPerson: false,
      // showPopup: false,
      // loginFlag: false,
      business: "",
    };
  },
  computed: {

    showPerson() {
      if (getUSER() && getJWT()) {
        return true;
      } else if (this.$store.state.user && getUSER()) {
        return true;
      } else {
        return false;
      }
    },
    showImg() {
      // 获取缓存中的用户信息
      this.userInfo = getUSER();
      if (this.userInfo.photo) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    // 跳转链接
    toUrl(url) {
      this.$router.push(url);
    },
    // 跳转重要产业
    toKey(n) {
      console.log(n);
      this.$router.push({
        path: "/keyindustries",
        query: { type: n },
      });
    },

    // 跳转我的收藏
    toCollection() {
      if (getUSER() && getJWT()) {
        this.$router.push({
          path: "/collection",
        });
      } else if (this.$store.state.user && getUSER()) {
        this.$router.push({
          path: "/collection",
        });
      } else {
        // 未登录：跳转统一登录入口
        this.loginUser();
      }
    },

    register() {
      //注册,全局使用this.$register()
      //this.$register();
      this.$message.info("正在前往统一注册入口", {
        duration: 2000,
      });
      getRequest({ url: "/api/v1/user/getRegisterUrl" }).then((res) => {
        if (res.errcode == 200) {
          window.location.href = res.data.url;
        } else {
          this.$message.error(res.errmsg);
        }
      });
      // window.location.href = getRegisterUrl();
    },
    loginUser() {
      this.$message.info("正在前往统一登录入口", {
        duration: 2000,
      });
      getRequest({ url: "/api/v1/user/getLoginUrl" }).then((res) => {
        if (res.errcode == 200) {
          window.location.href = res.data.url;
        } else {
          this.$message.error(res.errmsg);
        }
      });
      // 登录全局使用this.$login()
      // this.$login({
      //  login: (data) => {
      //    if (data) {
      //       // 登录回调函数
      //      this.$store.commit("setUser", data);
      //    }
      //  },
      // });
    },
    handleShow(val) {
      this.showPopup = false;
      // this.showPerson = val;
    },
    // 个人中心
    jumpPage() {
      this.$router.push({
        path: "/my",
      });
    },
    // 退出登录
    out() {
      removeUSER();
      // const backLength = window.history.length - 1;
      // this.$router.go(-backLength);
      this.$router.replace({ path: "/" });
      location.reload();
    },
    // 知识产权图片
    homese() {
      this.$router.push({
        path: "/",
      });
    },
    gointo() {
      this.showPopup = true;
    },
    //金融服务(知识产权质押融资)
    service() {
      this.$router.push({
        path: "/financialservice",
      });
    },
    //金融服务(知识产权质物处置)
    service2() {
      this.$router.push({
        path: "/financialservice2",
      });
    },
    //金融服务(知识产权资本运作)
    operation() {
      this.$router.push({
        path: "/capitaloperation",
      });
    },
    //金融服务(服务科创板)
    plate() {
      this.$router.push({
        path: "/service",
      });
    },
  },
  created() {
    // this.loginFlag = localStorage.getItem('loginFlag');
    // console.warn('iufdhsi ',this.loginFlag);
    const code = getUrlParam('code');
    console.log('code', code);

    if (code) {
      getRequest({
        url: "/security/getUserToken?code=" + code
      }).then((res) => {
        if (res.errcode == 200) {
          console.log('update jwt', res.data.token);

          setJWT(res.data.token);
          setUSER(res.data.userPO);

          this.$store.commit("setUser", res.data);
          //setTimeout(() => {
          //  window.location.href = '/property-page/';
          //}, 500);
        }
      });
    }


  },
};
</script>

<style lang="scss" scoped>
.personal {
  width: 20%;
  // display: flex;
  // align-items: center;
  font-size: 14px;
  color: #1d2129;

  // justify-content: space-between;
  &>div {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  img {
    width: 32px;
    height: 32px;
    margin-right: 8px;
    border-radius: 50%;
  }
}

.choice {
  display: flex;
  width: 80%;
  min-width: 1380px;
  justify-content: space-between;
  align-items: center;
  // margin: 13px 150px;
  margin: 10px auto;

  .turn {
    display: flex;
    align-items: center;
  }

  .img1 {
    width: 287.5px;
    height: 50px;
    cursor: pointer;
  }

  .img2 {
    width: 258px;
    height: 39px;
    cursor: pointer;
  }

  .dropdown {
    width: 55%;
    padding-left: 60px;
    padding-right: 36px;
  }

  .Bar {
    color: #e5e6eb;
    margin: 0 12px;
  }
}
</style>
